import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-usage-exceeded',
  templateUrl: './usage-exceeded.component.html',
  styleUrls: ['./usage-exceeded.component.scss']
})
export class UsageExceededComponent implements OnInit {
  constructor(
    private location: Location
  ) {
  }

  ngOnInit(): void {
  }

  retry(): void {
    this.location.back();
  }
}
